import React, { useState, useCallback } from 'react'

export interface Props {
  text?: string | number
  handleChange?: (text: string, name?: string) => void
  handleKeyDown?: (event: any, text: string, setText: (text: string) => void) => boolean
  handleButtonPressed?: (text: string) => boolean
  placeholder?: string
  icon?: string
  type?: string
  name?: string
  width?: string
}

const TextInput: React.FC<Props> = ({
  text,
  handleChange,
  handleKeyDown,
  handleButtonPressed,
  placeholder,
  icon,
  type,
  name,
  width,
}) => {
  const [internalText, setInternalText] = useState('')

  const setText = useCallback((t: string) => {
    setInternalText(t)
  }, [])

  const onChange = (event: any) => {
    const inputText = event.target.value
    setInternalText(inputText)
    handleChange && handleChange(inputText, name)
  }

  const onKeyDown = (event: any) => {
    if (handleKeyDown) {
      const res = handleKeyDown(event, internalText, setText)
      if (res) {
        setInternalText('')
      }
    }
  }

  const onClick = () => {
    if (handleButtonPressed) {
      const res = handleButtonPressed(internalText)
      if (res) {
        setInternalText('')
      }
    }
  }

  const inputValue = typeof text !== 'undefined' ? text : internalText
  const containerStyle: React.CSSProperties = {}
  typeof width !== 'undefined' && (containerStyle.width = width)

  return (
    <div className="inline-block min-w-[120px]" style={containerStyle}>
      <input
        className={
          'text-gray-800 font-extralight outline-hidden border-0 w-[90%] text-sm h-[40px] border-b! border-gray-200! ring-offset-0'
        }
        value={inputValue}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        type={type ? type : 'text'}
      />
      {icon ? (
        <button
          className="border-none text-xl rounded-lg text-gray-100 bg-none mt-[5px]"
          onClick={onClick}
          disabled={!inputValue}
          type="submit"
        >
          <i className={`material-icons ml-[5px] mr-[5px] text-gray-400`}>{icon}</i>
        </button>
      ) : null}
    </div>
  )
}

export default TextInput
